// Medagliere completo Club Atletico Bologna (estratto dalle immagini fornite)

export const MEDAGLIERE_INTRO =
  "Oltre settant'anni di podi, sotto la stessa bandiera. Dai Giochi Olimpici del 1948 ai titoli mondiali master dei nostri giorni, ecco il palmares completo del Club Atletico Bologna.";

export const MEDAGLIERE_SECTIONS = [
  {
    id: "lotta",
    title: "Lotta Greco-Romana e Stile Libero",
    kicker: "Il cuore storico del club",
    athletes: [
      {
        name: "Guido Fantoni",
        azzurro: true,
        results: [
          "Bronzo Olimpiadi di Londra 1948",
          "Bronzo Campionato del Mondo 1951",
          "Oro Giochi del Mediterraneo 1951",
          "Campione Italiano Assoluti Pesi Massimi: 1948 · 1949 · 1950",
        ],
      },
      { name: "Sergio Montanari", results: ["Campione Italiano Assoluti Pesi Leggeri: 1948 · 1949 · 1950"] },
      { name: "Giorgio Lolli", results: ["Campione Italiano 2ª Serie: 1949 · 1951"] },
      { name: "Graziano Dall'Olmo", results: ["Campione Italiano 3ª Serie: 1946"] },
      { name: "Demetrio Bergonzoni", results: ["Campione Italiano 3ª Serie: 1946"] },
      { name: "Alberto Berselli", results: ["Campione Italiano CUS: 1948"] },
      { name: "Marco Viggi", results: ["Campione Italiano CUS: 1950"] },
      { name: "Carlo Vignoli", results: ["Campione Italiano 3ª Serie: 1953"] },
      {
        name: "Giuseppe Pirazzoli",
        azzurro: true,
        results: [
          "Oro Giochi del Mediterraneo · Barcellona 1955",
          "Campione Italiano: 1954 · 1955 · 1957 · 1958 · 1959 · 1960 · 1961 · 1962",
        ],
      },
      { name: "Mario Tassinari", results: ["Campione Italiano 3ª Serie: 1957"] },
      { name: "Italo Gennelli", results: ["Campione Italiano Assoluti: 1960 · 1962"] },
      { name: "G. Guido Roncarati", results: ["Campione Italiano Assoluti: 1963"] },
      {
        name: "Marziano Magnani",
        azzurro: true,
        results: ["Atleta Olimpico · Roma 1960", "Campione Italiano Assoluti: 1964 · 1965"],
      },
      { name: "Giuseppe Guastadini", results: ["Campione Italiano Assoluti: 1964 · 1967"] },
      { name: "Giorgio Grillini", results: ["Campione Italiano Seniores: 1970"] },
      { name: "Fulvio Stanzani", results: ["Campione Italiano Studenteschi: 1972"] },
      { name: "Giuliano Capuzzi", results: ["Campione Italiano CUS: 1973"] },
      { name: "Luigi De Montis", results: ["Campione Italiano Assoluti: 1975 · 1976"] },
      {
        name: "Alberto Bargossi",
        results: [
          "Campione Italiano CUS: 1969 · 1970 · 1971 · 1972 · 1973 · 1975",
          "Campione Italiano Junior: 1966",
        ],
      },
      {
        name: "Stefano Raspadori",
        results: [
          "Campione Italiano Speranze: 1978",
          "Mondiali Master: 2000 · 2002 Plovdiv · 2006 Riga · 2007 Szombathely",
        ],
      },
      { name: "Massimo Broccati", results: ["Campione Italiano Speranze: 1983"] },
      { name: "Daniele Marchi", results: ["Mondiali Master: 2009 Kovola · 2010 Belgrado · 2011 Racibórz"] },
      {
        name: "Alessandro Zappalà",
        results: [
          "Vice Campione del Mondo Master 2025 · Greco-Romana",
          "Campione Italiano Master: 2022 · 2024 · 2025",
          "Numerosi Trofei Nazionali (Modigliana, CISA)",
        ],
      },
      {
        name: "Dimitru Popov",
        results: [
          "Campione Mondiale Master G.R.: 2018 · 2019 · 2022 · 2023",
          "Vincitore Trofei Nazionali e Internazionali",
        ],
      },
      { name: "Alex Cecati", results: ["Oro Coppa Italia 2012 · Como", "Vincitore Tornei Internazionali"] },
      { name: "Nicolae Esanu", results: ["Campione Italiano Cadetti: 2017"] },
      { name: "Gabriel Lupasco", results: ["Campione Italiano Under 20: 2022"] },
      { name: "Salvatore Iacono", results: ["Campione Italiano Classe Ragazzi: 2023"] },
      { name: "Claudio Evangelisti", results: ["Campione Italiano Master Greco-Romana: 2024 · 2025"] },
      { name: "Giovanni Mangione", results: ["Campione Italiano CUS: 2025"] },
    ],
  },
  {
    id: "squadra",
    title: "Titoli di Squadra · C.A.B.",
    kicker: "Risultati collettivi",
    team: [
      "1ª Classificata Trofeo Bologna 2025 · 2026",
      "1ª Classificata Open Italia 2025",
      "Vincitrice Coppa Italia Senior 2023 · 2025",
      "Campione d'Italia Master Greco-Romana 2022",
    ],
  },
  {
    id: "bjj",
    title: "BJJ / Grappling",
    kicker: "La tradizione si evolve",
    athletes: [
      {
        name: "Martina Baraccani",
        results: [
          "Europei Senior FILA 2013 · Polonia",
          "Mondiali Senior BJJ 2013 · Canada",
          "Mondiali Senior No-Gi 2013 · Canada",
          "Campionessa Italiana 2014",
        ],
      },
      {
        name: "Stefano Raspadori",
        results: ["Campione del Mondo Veterani 2010 · Croazia", "Campione Italiano Assoluto 2011 · Ostia"],
      },
    ],
  },
  {
    id: "pesi",
    title: "Sollevamento Pesi",
    kicker: "Forza e metodo",
    athletes: [
      { name: "Luigi Lodi", results: ["Campione Italiano 3ª Serie: 1965"] },
      { name: "Umberto Lattazio", results: ["Campione Italiano ENAL: 1966"] },
      {
        name: "Maurizio Bombacci",
        azzurro: true,
        results: ["10 volte Campione Italiano Assoluto (1993 · 2012)", "Campione Mondiale Master 2014"],
      },
      { name: "Enrico Majerna (-67 kg)", results: ["Oro Italiani Universitari 2025"] },
      { name: "Luca Parlascino (-81 kg)", results: ["Oro Italiani Universitari 2025"] },
    ],
  },
  {
    id: "biathlon",
    title: "Biathlon",
    kicker: "Discipline di forza pura",
    athletes: [
      { name: "Roberto Stanzani", results: ["Campione Italiano Seniores 2003"] },
      { name: "Yuri Maenza", results: ["Campionato Italiano Seniores 2009"] },
      { name: "Beatrice Nadalini", results: ["Campionessa Italiana Juniores 2010 · 2011"] },
      { name: "Luiz Landuzzi", results: ["Campione Italia Nord 2011"] },
    ],
  },
  {
    id: "panca",
    title: "Distensione su Panca",
    kicker: "Powerlifting",
    athletes: [
      { name: "Marco Monti", results: ["Campione Italiano Universitario 2013 · 2014"] },
      { name: "Beatrice Nadalini", results: ["Campionessa Italiana Juniores 2010"] },
    ],
  },
];
